import React from 'react'
import { Container, TextField, RangeField, CheckboxSelectField } from '../Fields'

import {
    ranCountOptions,
    floorOptions,
    mmrOptions,
    blackbookOptions,
    lotOptions,
    saleStatusOptions,
} from './selectOptions'

export const SaleView: React.VFC = () => {
    return (
        <Container>
            <CheckboxSelectField
                label="Status"
                name="filters.sale.saleStatus"
                options={saleStatusOptions as string[][]}
                multiple
                valueAsString
            />
            <TextField label="Sale Date Offset" name="filters.sale.saleDate" placeholder="Try '15' or '15+'" />
            <TextField label="Lane" name="filters.sale.lane" placeholder="Try '1X' or '1X,2X,3X" />
            <TextField label="Run" name="filters.sale.run" placeholder="Try '3' or '3, 4, 5'" />
            <RangeField
                label="Ran Count"
                selectProps={{
                    name: 'filters.sale.ranCount',
                    options: ranCountOptions,
                }}
                lowProps={{ name: 'filters.sale.ranCountLow', placeholder: "Try '1'" }}
                highProps={{
                    name: 'filters.sale.ranCountHigh',
                    placeholder: "Try '20'",
                }}
            />
            <RangeField
                label="Run Order"
                selectProps={{ name: 'filters.sale.lot', options: lotOptions }}
                lowProps={{ name: 'filters.sale.lotLow', placeholder: "Try '1'" }}
                highProps={{ name: 'filters.sale.lotHigh', placeholder: "Try '20'" }}
            />
            <RangeField
                label="Floor"
                selectProps={{ name: 'filters.sale.floor', options: floorOptions }}
                lowProps={{ name: 'filters.sale.floorLow', placeholder: "Try '1000'" }}
                highProps={{
                    name: 'filters.sale.floorHigh',
                    placeholder: "Try '10000'",
                }}
            />
            <RangeField
                label="MMR"
                selectProps={{ name: 'filters.sale.mmr', options: mmrOptions }}
                lowProps={{ name: 'filters.sale.mmrLow', placeholder: "Try '1000'" }}
                highProps={{ name: 'filters.sale.mmrHigh', placeholder: "Try '20000'" }}
            />
            <RangeField
                label="Blackbook"
                selectProps={{
                    name: 'filters.sale.blackbook',
                    options: blackbookOptions,
                }}
                lowProps={{
                    name: 'filters.sale.blackbookLow',
                    placeholder: "Try '1000'",
                }}
                highProps={{
                    name: 'filters.sale.blackbookHigh',
                    placeholder: "Try '20000'",
                }}
            />
        </Container>
    )
}

export default SaleView
